import React from "react";
import classes from './Videos.module.scss';
import { useTranslation } from "react-i18next";
import preview from '../../../img/SNB.png';

const videos = [
    {
        title: 'education_video_title_01',
        name: '01.mp4',
    },
    {
        title: 'education_video_title_02',
        name: '02.mp4',
    },
    {
        title: 'education_video_title_03',
        name: '03.mp4',
    },
    {
        title: 'education_video_title_04',
        name: '04.mp4',
    },
];

const Videos = () => {
    const { t } = useTranslation();
    const serverDomain = 'https://storage.devindex.net/';
    return (
        <section className="container">
            <div className={classes.videos}>
                <h2 className={`${classes.title} font-48`}>
                    {t('education_title_01')}
                </h2>
                <div className={classes.content}>
                    {videos.map((video, index) =>
                        <div key={index} className={classes.videoWrap}>
                            <h4 className={classes.videoTitle}>
                                {t(video.title)}
                            </h4>
                            <video 
                                controls
                                preload="metadata"
                                controlsList="nodownload"
                                poster={preview}
                                className={classes.video}
                            >
                                <source src={`${serverDomain}/videos/g/${video.name}`} type="video/mp4" />
                            </video>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Videos;
